<template>
  <div class="audience-size">
    <template v-if="displaySize || displaySize === 0">
      <svg-icon :icon="audience" :width="56" :height="33"></svg-icon>
      <div class="h2 mt-5">{{ displaySize | truncateAmount }}</div>
      <div class="subtitle-1 audience-size__text">Target Audience (Age 18+)</div>
      <viewership-time-frame :validStreamingOptions="validStreamingOptions" v-on:selected="onSelectedViewingStream" :selectedViewshipOption="viewershipOption" />
    </template>
  </div>
</template>

<script>
  import SvgIcon from '@/components/common/svgIcon/index'
  import audience from '@/assets/svg/audience.svg'
  import truncateAmount from '@/filters/truncateAmount'
  import ViewershipTimeFrame from './ViewershipTimeFrame'

  export default {
    components: {
      SvgIcon,
      ViewershipTimeFrame
    },
    filters: {
      truncateAmount
    },
    props: {
      size: Number,
      viewershipOption: String,
      validStreamingOptions: Array,
      onSelectedViewingStream: Function
    },
    data () {
      return {
        audience
      }
    },
    computed: {
      displaySize () {
        return this.size || this.size === 0 ? this.size : null
      }
    }
  }
</script>

<style lang="scss">
  .audience-size {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;

    h2 {
      margin: 20px 0 0 0;
    }

    svg {
      fill: color(blues, normal)
    }

    &__text {
      margin-top: 10px;
      margin-bottom: 24px;
      font-size: rem(17);
      line-height: rem(20);
    }
  }
</style>



// WEBPACK FOOTER //
// AudienceSize.vue?99dba74e